import { IRootState } from '../../../store'
import { IOperationsOptionsState } from '../store/options.types'

export const getOperationsOptionsSelector = (state: IRootState): IOperationsOptionsState =>
  state.options.operationsOptions
